import styled from 'styled-components'
import colors from '../../../configuration/colors'
import ExpandSvg from '../../../static/images/FlyoutPanel/icon_expand.svg'
import CollapseSvg from '../../../static/images/FlyoutPanel/icon_collapse.svg'
import EvidenceTooltipSvg from '../../../static/images/Skills/icon_info.svg'
import FlexAlignCenter from '../../styled/FlexAlignCenter'
import { Caption1, H3, H5 } from '../../styled/typography/typography'

export const NameWithIcon = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;

  &::before {
    content: '';
    width: ${props => props.iconSize};
    height: ${props => props.iconSize};
    margin-right: 8px;
    background: url(${props => props.icon}) center/contain no-repeat;
  }
`

// https://github.com/wwayne/react-tooltip/issues/57
const tooltipWidth = 286
export const tooltipOffset = 108
export const TooltipWrapper = styled(Caption1)`
  .__react_component_tooltip {
    max-width: ${tooltipWidth}px;
    padding: 10px 15px;
    background: ${props => props.theme.selectBackground} !important;
    color: ${props => props.theme.caption1color};
    box-shadow: 0 0 10px 0 rgba(0,0,0,0.1);
    border-radius: 10px !important;
    border:  ${props => props.theme.masterSelectBorder} !important;

    &.place-top {
      &:before {
        border-top-color: ${props => props.theme.selectBackground} !important;
      }

      &:after {
        border-top-color: ${props => props.theme.selectBackground} !important;
      }
  }

  .__react_component_tooltip.place-top::after {
    left: ${tooltipWidth/2 + tooltipOffset}px;
  }

  .__react_component_tooltip.place-top::before {
    left: ${tooltipWidth/2 + tooltipOffset}px;
  }
`

export const EvidenceTooltipIcon = styled.img.attrs({
  src: EvidenceTooltipSvg
})`
  width: 12px;
  height: 12px;
  margin-left: 6px;
`

const SkillsLabel = styled(H3)`
  margin-bottom: 13px;
  font-family: Montserrat,serif;
  font-weight: 600;
`

const Panel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: ${props => (props.top > 0 ? `calc(100% - ${props.top})` : '100%')};
  padding: ${props =>
          props.isCollapsed ? 0 : `${props.paddingTop} 18px 100px 20px`};
  width: ${props => (props.isCollapsed ? 0 : props.width)};
  background: ${colors.smoke};
  box-shadow: 0 1px 9px 0 rgba(0, 0, 0, 0.15);
  overflow-y: auto;
  z-index: 10;
  transition: width 0.3s ease;
`

const ToggleButton = styled.div`
  position: fixed;
  display: none;
  top: 22px;
  right: ${props => (props.isCollapsed ? 0 : props.width)};
  height: 28px;
  width: 28px;
  border-radius: 5px 0 0 5px;
  background-color: ${colors.victoria};
  background-image: url(${props =>
          props.isCollapsed ? ExpandSvg : CollapseSvg});
  background-repeat: no-repeat;
  background-size: 9px 15px;
  background-position: 50%;
  cursor: pointer;
  transition: right 0.25s ease;

  @media all and (max-width: 1024px) {
    display: block;
  }
`

const SkillsOl = styled.ol`
  margin: 0;
  padding: 0 0 ${props => (props.displayVertically ? '37px' : '0')};
`

const ListItem = styled.li`
  min-height: 30px;
  width: 100%;
  padding: 0;
  border-radius: 5px;
  transition: border 0.3s ease, padding 0.3s ease;
  cursor: inherit;
`

const SkillDiamondColumn = styled(FlexAlignCenter)`
  justify-content: center;
  height: 100%;
  width: 20px;
  min-width: 20px;
  margin-right: 8px;
  transition: opacity 0.3s ease, width 0.3s ease;
`

const SkillTextColumn = styled.div`
  padding: 0 12px 0 0;

  .evidence-statements-react-tooltip {
    max-width: 250px;
  }
`

const Diamond = styled.div`
  height: 12px;
  width: 12px;
  margin-top: 2px;
  border-radius: 2px;
  border: 1px solid
    ${props =>
  props.hasMasteries || props.displayMasteries
    ? colors.ash
    : colors.silver};
  transform: rotate(45deg);
  background: ${props => props.backgroundColor};
  transition: background-color 0.3s ease-in-out;
`

const H5SkillName = styled(H5)`
  margin: 0;
  cursor: inherit;
`

export {
  SkillsLabel,
  Panel,
  ToggleButton,
  SkillsOl,
  ListItem,
  SkillDiamondColumn,
  SkillTextColumn,
  Diamond,
  H5SkillName
}
